import * as turf from '@turf/turf'

type StrataPolygon = turf.Feature<turf.Polygon | turf.MultiPolygon>

const hasPolygonGeometry = (feature: turf.Feature): feature is StrataPolygon =>
  feature?.geometry?.type === 'Polygon' || feature?.geometry?.type === 'MultiPolygon'

// Manual sites are matched against the uncropped polygon so they may sit inside exclusion areas;
// strata without one fall back to the cropped polygon.
export const buildManualSiteStrata = (
  stratas?: turf.FeatureCollection,
  uncroppedStratas?: turf.FeatureCollection,
): turf.FeatureCollection => {
  const uncroppedById = new Map(
    (uncroppedStratas?.features ?? [])
      .filter(hasPolygonGeometry)
      .map(strata => [strata.properties?.id, strata]),
  )
  return turf.featureCollection(
    (stratas?.features ?? []).map(strata => uncroppedById.get(strata.properties?.id) ?? strata),
  )
}

export const findManualSiteStratum = ({
  point,
  manualSiteStrata,
  selectedStrataId,
}: {
  point: turf.Feature<turf.Point>
  manualSiteStrata?: turf.FeatureCollection
  selectedStrataId?: string | number
}): StrataPolygon | null => {
  const candidates = (manualSiteStrata?.features ?? []).filter(strata =>
    selectedStrataId == null
      ? strata.properties?.belongToFarm
      : strata.properties?.id === selectedStrataId,
  )
  return (
    candidates
      .filter(hasPolygonGeometry)
      .find(strata => turf.booleanPointInPolygon(point, strata)) ?? null
  )
}
